<template>
    <div class="row">
        <div class="col-12 col-md-8 offset-md-2 col-lg-6 offset-lg-4 col-xl-8 offset-xl-2">
            <p 
                class="content-text content-text--title"
                v-if="item.type == 'heading'"
                :key="key">
                {{value.title}}
            </p>
        </div>
    </div>
</template>

<script>
export default {
    name:'Header',
    props:['value']
}
</script>